<template>
    <div class="skill-progress">
        <p class="skill-name">{{skillIn.title}}</p>
        <b-progress :max="skillIn.max">
            <b-progress-bar :value="skillIn.value"
                            :label="String(skillIn.value)"
                            :variant="getVariants()"
                            animated>
            </b-progress-bar>
        </b-progress>
    </div>
</template>

<script>
export default {
    name: "design-2021-learning-path-show-skill-progress-component",
    props: {
        skillIn: {
            type: Object,
            required: true,
        },
    },
    methods: {
        getVariants(){
            const percentage = this.skillIn.value / this.skillIn.max * 100;
            if(percentage < 50){
                return 'danger';
            } else if(percentage >= 50 && percentage < 70) {
                return 'warning'
            } else {
                return 'success';
            }
        }
    }
}
</script>

<style scoped lang="scss">
    .skill-progress {
        .skill-name {
            margin-bottom: 0;
            font-weight: $font-weight-medium;
        }
    }

    ::v-deep .progress {
        height: 12px;
    }
</style>
